namespace Areas.Ucla.Upload {
    "use strict";

    export function uploadError(e: any) {
        const defaultTimeOut = 4000;

        const responseText = e.request.responseText;

        const toastrOptions = { timeOut: defaultTimeOut, positionClass: "toast-bottom-full-width", showMethod: "show" };
        toastr.error(responseText, "Error", toastrOptions);
    }
}